// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  groupId: __t.u64().primaryKey().name("group_id"),
  name: __t.string(),
  charterRef: __t.string().name("charter_ref"),
  hallWorldId: __t.u64().name("hall_world_id"),
  treasurySov: __t.i64().name("treasury_sov"),
  state: __t.string(),
  reviewUntil: __t.timestamp().name("review_until"),
  createdAt: __t.timestamp().name("created_at"),
});
